import { useCallback } from 'react';
import { useStore, StoreTypes } from 'context';
import { EventBus } from 'events/EventBus';
import { ReaderToolsEvent } from 'events/EventTypes';
import * as types from 'constants/actionTypes';
import { ReaderToolType } from 'constants/ReaderTools';
import { useGAEvent } from 'components/AppService/GAService';

export const useStopwatchCommand = () => {
    const { gaEvent } = useGAEvent();
  const [_, globalDispatch] = useStore(StoreTypes.global);

    const execute = useCallback(async () => {
        gaEvent('工具列_碼表');
        try {

          globalDispatch({ type: types.OPEN_STOPWATCH_MODAL })
          EventBus.emit({
            event: ReaderToolsEvent.ClickReaderToolBoxEvent,
            payload: {
              isToolboxShow: false
            }
          })
        } catch (e) {
            console.error('StopwatchCommand execute error', e);
        }
    }, [globalDispatch, gaEvent]);

    return { execute };
};
